import { Box } from '@mantine/core';
import FileThumbnail from 'components/files/FileThumbnail';
import { useState } from 'react';
import Slider from 'components/modals/slider/Slider';

interface DeviceImageFile {
  fileId: string;
  isMainImage: boolean;
}

/**
 * Displays the main image of the device and opens the slider with more images.
 */
export default function DeviceImage({
  imageFiles = [],
  opacity = 1,
}: {
  imageFiles?: DeviceImageFile[];
  opacity?: number;
}) {
  const [openedSlider, setOpenSlider] = useState(false);

  const mainImage = imageFiles.find((image) => image.isMainImage) || null;

  return mainImage ? (
    <Box p={8} w={60} h={60} miw={60} mih={60} mah={60} maw={60} style={{ opacity }}>
      <FileThumbnail fileId={mainImage.fileId!} onOpenSlider={() => setOpenSlider(true)} />
      <Slider
        key={mainImage.fileId}
        opened={openedSlider}
        fileIds={imageFiles.map((image) => image.fileId)}
        onClose={() => setOpenSlider(false)}
        initialImageId={mainImage.fileId}
      />
    </Box>
  ) : (
    <Box w={60} h={60} miw={60} mih={60} mah={60} maw={60} />
  );
}
